/**
 * ZipFit attribution bootstrap — persists passport_ref across sessions and cart updates.
 */
(function () {
  const COOKIE_NAME = 'zipfit_passport_ref';
  const FIT_QUIZ_COOKIE = 'zipfit_fit_quiz_ref';
  const COOKIE_MAX_AGE_DAYS = 30;
  const ROOT_DOMAIN = '.zipfit.com';

  function readParams() {
    return new URLSearchParams(window.location.search);
  }

  function readCookie(name) {
    const escaped = name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');
    const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value) {
    const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    const base = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
    document.cookie = `${base}; Domain=${ROOT_DOMAIN}`;
    document.cookie = base;
  }

  function isFitQuizPage() {
    return /\/pages\/(?:fit-quiz|zip-quiz|quiz-results)(?:\/|$)/.test(window.location.pathname);
  }

  function normalizeRefs(params) {
    const ref = (params.get('ref') || '').trim();
    const passportRef = (params.get('passport_ref') || ref || '').trim();
    const partnerRef = (params.get('partner_ref') || '').trim();
    const fitQuizFromParam = (params.get('fit_quiz_ref') || '').trim();
    const fitQuizFromRecall = isFitQuizPage() ? (params.get('s') || '').trim() : '';
    const fitQuizRef = fitQuizFromParam || fitQuizFromRecall;
    const token = (params.get('token') || '').trim();
    const onPassportCard = window.location.pathname.includes('/pages/passport-card');
    const effectivePassportRef = passportRef || (onPassportCard ? token : '');
    return {
      passport_ref: effectivePassportRef,
      partner_ref: partnerRef,
      fit_quiz_ref: fitQuizRef,
    };
  }

  function updateCartAttributes(attrs) {
    const payload = { attributes: attrs };
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).catch(function () {
      /* cart update is best-effort */
    });
  }

  function bootstrap() {
    const params = readParams();
    const refs = normalizeRefs(params);
    const cookieRef = readCookie(COOKIE_NAME);
    const passportRef = refs.passport_ref || cookieRef;
    const fitQuizCookie = readCookie(FIT_QUIZ_COOKIE);
    const fitQuizRef = refs.fit_quiz_ref || fitQuizCookie;

    if (passportRef) {
      writeCookie(COOKIE_NAME, passportRef);
    }
    if (fitQuizRef) {
      writeCookie(FIT_QUIZ_COOKIE, fitQuizRef);
    }

    const cartAttrs = {};
    if (passportRef) {
      cartAttrs.passport_ref = passportRef;
    }
    if (refs.partner_ref) {
      cartAttrs.partner_ref = refs.partner_ref;
    }
    if (fitQuizRef) {
      cartAttrs.fit_quiz_ref = fitQuizRef;
    }
    if (Object.keys(cartAttrs).length) {
      updateCartAttributes(cartAttrs);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
